export const filterBySearch = (source, value) => {
  return source.filter(s => s.name.toLowerCase().includes(value.toLowerCase()));
};